import { ReactElement } from 'react'

import { ConditionalWrapper } from 'components/ConditionalWrapper'
import { Flex, Icon } from 'components/core'

import * as styles from './styles.scss'
import { TypeaheadMenuItemProps } from './types'
import { useAnnotatedText } from './useAnnotatedText'

/**
 * Underline matches found in option string
 *
 * @param item
 * @param query
 */
const TypeaheadMenuItem = ({
    item,
    query,
    highlightQuery = true,
    isSelected,
}: TypeaheadMenuItemProps): ReactElement => {
    const annotatedLabel = useAnnotatedText({
        text: item.label,
        query,
        highlightQuery,
    })
    return (
        <ConditionalWrapper
            condition={isSelected}
            wrapper={(children) => (
                <Flex justifyContent="space-between">
                    {children}
                    <Icon name="CHECKMARK" color="primary" />
                </Flex>
            )}
        >
            <Flex justifyContent="space-between" alignItems="center">
                <span>
                    {item.toBeCreated && (
                        <div>
                            <span
                                className={
                                    styles['typeahead-menu-item-to-be-created']
                                }
                            >
                                Create &quot;
                            </span>
                            <b>{item.label}</b>
                            <span
                                className={
                                    styles['typeahead-menu-item-to-be-created']
                                }
                            >
                                &quot;
                            </span>
                        </div>
                    )}
                    {!item.toBeCreated && (
                        <b
                            className={styles['typeahead-menu-item-label']}
                            dangerouslySetInnerHTML={{
                                __html: annotatedLabel,
                            }}
                        />
                    )}

                    {!item.toBeCreated && item.metadata && (
                        <span>
                            {' '}
                            (<em>{item.metadata}</em>)
                        </span>
                    )}
                </span>
            </Flex>
        </ConditionalWrapper>
    )
}

export default TypeaheadMenuItem
